export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    pre_descripcion: item.pre_descripcion || "Presentación no disponible",
  }));
